import apiClient from './client';

// Likes on comments, images and references (`targetKind` from TARGET_KINDS).
// Both directions are idempotent and return {like_count, liked_by_me}.

export const like = (targetKind, id) =>
  apiClient.put(`/likes/${targetKind}/${id}`).then((r) => r.data);

export const unlike = (targetKind, id) =>
  apiClient.delete(`/likes/${targetKind}/${id}`).then((r) => r.data);

export const setLiked = (targetKind, id, liked) =>
  liked ? like(targetKind, id) : unlike(targetKind, id);
